"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatType = exports.ChatCmd = void 0;
var ChatCmd;
(function (ChatCmd) {
    ChatCmd[ChatCmd["PING"] = 0] = "PING";
    ChatCmd[ChatCmd["PONG"] = 10000] = "PONG";
    ChatCmd[ChatCmd["CONNECT"] = 100] = "CONNECT";
    ChatCmd[ChatCmd["CONNECTED"] = 10100] = "CONNECTED";
    ChatCmd[ChatCmd["REQUEST_RECENT_CHAT"] = 5101] = "REQUEST_RECENT_CHAT";
    ChatCmd[ChatCmd["RECENT_CHAT"] = 15101] = "RECENT_CHAT";
    ChatCmd[ChatCmd["EVENT"] = 93006] = "EVENT";
    ChatCmd[ChatCmd["CHAT"] = 93101] = "CHAT";
    ChatCmd[ChatCmd["DONATION"] = 93102] = "DONATION";
    ChatCmd[ChatCmd["KICK"] = 94005] = "KICK";
    ChatCmd[ChatCmd["BLOCK"] = 94006] = "BLOCK";
    ChatCmd[ChatCmd["BLIND"] = 94008] = "BLIND";
    ChatCmd[ChatCmd["NOTICE"] = 94010] = "NOTICE";
    ChatCmd[ChatCmd["PENALTY"] = 94015] = "PENALTY";
    ChatCmd[ChatCmd["SEND_CHAT"] = 3101] = "SEND_CHAT";
})(ChatCmd = exports.ChatCmd || (exports.ChatCmd = {}));
var ChatType;
(function (ChatType) {
    ChatType[ChatType["TEXT"] = 1] = "TEXT";
    ChatType[ChatType["IMAGE"] = 2] = "IMAGE";
    ChatType[ChatType["STICKER"] = 3] = "STICKER";
    ChatType[ChatType["VIDEO"] = 4] = "VIDEO";
    ChatType[ChatType["RICH"] = 5] = "RICH";
    ChatType[ChatType["DONATION"] = 10] = "DONATION";
    ChatType[ChatType["SUBSCRIPTION"] = 11] = "SUBSCRIPTION";
    ChatType[ChatType["SYSTEM_MESSAGE"] = 30] = "SYSTEM_MESSAGE";
})(ChatType = exports.ChatType || (exports.ChatType = {}));
